import styled from 'styled-components';
var LogoWrapper = styled.img.withConfig({
  displayName: "Logostyles__LogoWrapper",
  componentId: "pantheon__sc-1j40ui-0"
})(["&:hover{cursor:pointer;}"]);
export { LogoWrapper };